import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { Adiantamento, Login, Relatorio } from 'eddydata-lib';

export class EtiquetaAdiantamento {
  protected static datepipe: DatePipe = new DatePipe('pt');

  constructor() {
  }

  static imprimir(lista: Adiantamento[], login: Login, messageService: MessageService) {
    if (!lista) {
      messageService.add({ severity: 'warn', summary: 'Validação', detail: 'Antes de imprimir salve o registro!' });
      return;
    }
    const listaConteudo = [];
    let y = 0;
    for (const entidade of lista) {
      const conteudo: {}[] = [
        {
          text: 'Processo: ' + ('000000' + entidade.numero).slice(-7), absolutePosition: { x: 90, y: 50 + y },
          fontSize: 14, bold: true
        },
        {
          text: [{
            text: 'Responsável: ', bold: true
          }, { text: entidade.empenho?.favorecido?.nome }],
          absolutePosition: { x: 45, y: 80 + y }
        },
        {
          text: [{
            text: 'Assunto: ', bold: true
          }, { text: entidade.motivo }],
          absolutePosition: { x: 45, y: 110 + y }
        },
        {
          columns: [{
            text: [{
              text: 'Empenho Nº: ', bold: true
            }, { text: + ('000000' + entidade.empenho?.numero).slice(-7) }]
            , width: 235, alignment: 'justify'
          }],
          absolutePosition: { x: 45, y: 125 + y }
        },
        {
          text: [{
            text: 'Data Início: ', bold: true
          }, { text: this.datepipe.transform(entidade.data_adiantamento, 'dd/MM/yyyy') }],
          absolutePosition: { x: 45, y: 95 + y }
        },
        {
          text: [{
            text: 'Valor: ', bold: true
          }, { text: entidade.valor_adiantado }],
          absolutePosition: { x: 175, y: 95 + y }
        },
      ];
      listaConteudo.push(conteudo);
      y += 100;
    }
    Relatorio.imprimirPersonalizado('ETIQUETA', login.usuario.nome, login.orgao.nome,
      login.brasao, listaConteudo, 'portrait', 'Etiquetas Adiantamento ', null, true, true);

  }
}
